import { appConfig, getTokenHeader } from "./settings";

class FrugalServicesClient {
    constructor() {
        this.baseUrl = appConfig.host;
        this.authUrl = appConfig.authHost;
    }

    async request(url, options = {}) {
        const headers = {
            ...getTokenHeader(),
            ...options.headers,
        };

        const config = {
            ...options,
            headers,
        };

        const response = await fetch(url, config);
        return response;
    }

    // Family API
    async getFamilyMembers() {
        return this.request(`${this.baseUrl}/api/v1/family/`, { method: 'GET' });
    }

    async addFamilyMember(accountId, firstName) {
        return this.request(`${this.baseUrl}/api/v1/family`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ accountId, firstName }),
        });
    }

    async deleteFamilyMember(id) {
        return this.request(`${this.baseUrl}/api/v1/family/${id}`, { method: 'DELETE' });
    }

    // Users API (from Auth Host)
    async getAccountUsers(accountId) {
        return this.request(`${this.authUrl}/api/v1/accounts/${accountId}/user/users`, { method: 'GET' });
    }

    // Categories API
    async getCategories() {
        return this.request(`${this.baseUrl}/api/v1/categories`, { method: 'GET' });
    }

    async checkCategory(category) {
        return this.request(`${this.baseUrl}/api/v1/categories/check?category=${category}`, { method: 'GET' });
    }

    async createCategory(categoryData) {
        return this.request(`${this.baseUrl}/api/v1/categories`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(categoryData),
        });
    }

    async deleteCategory(id) {
        return this.request(`${this.baseUrl}/api/v1/categories/${id}`, { method: 'DELETE' });
    }

    // Priority List API
    async getPriorityLists() {
        return this.request(`${this.baseUrl}/api/v1/priority-list`, { method: 'GET' });
    }

    async createPriorityList(priorityList) {
        return this.request(`${this.baseUrl}/api/v1/priority-list`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(priorityList),
        });
    }

    async updatePriorityList(priorityList) {
        return this.request(`${this.baseUrl}/api/v1/priority-list`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(priorityList),
        });
    }

    async deletePriorityList(id) {
        return this.request(`${this.baseUrl}/api/v1/priority-list/${id}`, { method: 'DELETE' });
    }

    // Transactions API
    async getTransactions(month, year) {
        return this.request(`${this.baseUrl}/api/v1/transactions/${month}/${year}`, { method: 'GET' });
    }

    async createTransaction(transaction) {
        return this.request(`${this.baseUrl}/api/v1/transactions`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(transaction),
        });
    }

    async updateTransaction(transaction) {
        return this.request(`${this.baseUrl}/api/v1/transactions/${transaction.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(transaction),
        });
    }

    async deleteTransaction(id) {
        return this.request(`${this.baseUrl}/api/v1/transactions/${id}`, { method: 'DELETE' });
    }

    async importTransactions(transactions) {
        const chunkedTransactions = [];
        const chunkSize = 100;
        for (let i = 0; i < transactions.length; i += chunkSize) {
            chunkedTransactions.push(transactions.slice(i, i + chunkSize));
        }

        return Promise.all(chunkedTransactions.map(chunk =>
            this.request(`${this.baseUrl}/api/v1/transactions/import`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(chunk),
            })
        ));
    }

    // Category Budgets API
    async getCategoryBudgets() {
        return this.request(`${this.baseUrl}/api/v1/category/budgets`, { method: 'GET' });
    }

    async createCategoryBudget(budgetData) {
        return this.request(`${this.baseUrl}/api/v1/category/budgets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(budgetData),
        });
    }

    async updateCategoryBudget(id, budgetData) {
        return this.request(`${this.baseUrl}/api/v1/category/budgets/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(budgetData),
        });
    }

    async deleteCategoryBudget(id) {
        return this.request(`${this.baseUrl}/api/v1/category/budgets/${id}`, { method: 'DELETE' });
    }

    // Feedback API
    async sendFeedback(feedbackData) {
        return this.request(`${this.baseUrl}/api/v1/customerFeedback`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(feedbackData),
        });
    }

    async createMealOption(mealOption) {
        console.log(mealOption);
        return this.request(`${this.baseUrl}/api/v1/meals`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mealOption),
        });
    }

    async getMealOptions() {
        return this.request(`${this.baseUrl}/api/v1/meals`, {
            method: 'GET'
        });
    }

    async deleteMealOption(id) {
        return this.request(`${this.baseUrl}/api/v1/meals/${id}`, {
            method: 'DELETE'
        });
    }
}

export default new FrugalServicesClient();